// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewWorkspace.test.tsx
import { type GetAskPunttReviewResponse } from "@mg/schemas/src/christo/askPunttReview";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import { type SavedReviewCommentFilter } from "./reviewCommentTags";
import { askV2ReviewKeys } from "./useAskPunttReview";

/** Writes the findings filter she chose onto the cached review, so it outlives a remount. */
export function usePersistReviewCommentFilter(reviewId: string | undefined) {
  const queryClient = useQueryClient();
  return useCallback(
    (filter: SavedReviewCommentFilter) => {
      if (!reviewId) return;
      queryClient.setQueryData<GetAskPunttReviewResponse>(
        askV2ReviewKeys.detail(reviewId),
        (prev) => {
          if (!prev) return prev;
          return {
            ...prev,
            review: {
              ...prev.review,
              commentFilter: {
                activeTags: [...filter.activeTags],
                alwaysOn: filter.alwaysOn,
                hiddenSources: [...filter.hiddenSources],
              },
            },
          };
        },
      );
    },
    [queryClient, reviewId],
  );
}
